<template>
  <bk-view class="shopLocation-container">
    <bk-view class="view-header">
			<bk-lang class="view-currentLocation" code="bkShopSearch_currentLocation"></bk-lang>
			<bk-view class="view-address">
				<bk-icon icon="icon-dingwei1"></bk-icon>
				<bk-view v-if="locInfo.address">{{locInfo.address}}</bk-view>
				<bk-lang v-else code="home_text_locErr"></bk-lang>
			</bk-view>
		</bk-view>
		<div id="container" class="view-map-warp"></div>

		<bk-view class="view-location-info" v-if="locInfo">
			<bk-view class="view-info-item">
				<bk-icon icon="icon-fi-rr-marker"></bk-icon>
				<bk-view>{{locInfo.country || '-'}}</bk-view>
			</bk-view>
			<bk-view class="view-info-item">
				<bk-icon icon="icon-fi-rr-marker"></bk-icon>
				<bk-view>{{locInfo.province || '-'}}</bk-view>
			</bk-view>
			<bk-view class="view-info-item">
				<bk-icon icon="icon-fi-rr-marker"></bk-icon>
				<bk-view>{{locInfo.district || '-'}}</bk-view>
			</bk-view>
			<bk-view class="view-info-item">
				<bk-icon icon="icon-fi-rr-marker"></bk-icon>
				<bk-view>{{locInfo.township || ''}}{{locInfo.street || ''}}</bk-view>
			</bk-view>
		</bk-view>
  </bk-view>
</template>

<script>
	import AMapLoader from '@vuemap/amap-jsapi-loader';

	export default {
		name:'shopLocation',
		props:{
			curRows:Object,
			locInfo:Object
		},
		address (){
			return this.locInfo;
		},
		mounted (){
			this.initMap();
		}, 
		methods:{
			initMap () {
				AMapLoader.load({
					key: 'ee98e576563dcc72e6d992ac51c0bc25',
				}).then((AMap) => {
        
					this.map = new AMap.Map('container', { //设置地图容器id
						resizeEnable: true,
						zoom: 13,
						center: [this.locInfo?.lng, this.locInfo?.lat],
					});
				}).catch((e) => {
					console.log(e);
				});
			},
	
		}
	};
</script>

<style lang="less">
@import './shopLocation.less';
</style>